import axiosInstance from '../utils/axios';

const BASE = '/location-dashboard';

const locationDashboardService = {
  getInsights: () => axiosInstance.get(`${BASE}/insights`).then((r) => r.data),
  getTodaysSales: () => axiosInstance.get(`${BASE}/todays-sales`).then((r) => r.data),
  getSalesReport: (startDate, endDate) =>
    axiosInstance.get(`${BASE}/sales-report`, { params: { startDate, endDate } }).then((r) => r.data),
  getMonthlySales: () => axiosInstance.get(`${BASE}/monthly-sales`).then((r) => r.data),
  getLowStockProducts: (threshold = 10) =>
    axiosInstance.get(`${BASE}/low-stock-products`, { params: { threshold } }).then((r) => r.data),
  getTopProducts: (limit = 5) =>
    axiosInstance.get(`${BASE}/top-products`, { params: { limit } }).then((r) => r.data),
  getPerformanceMetrics: () =>
    axiosInstance.get(`${BASE}/performance-metrics`).then((r) => r.data),
};

export default locationDashboardService;
